import { h, Component } from 'preact';

export default class Header extends Component {
  render() {
    return (
      <header class="flex">
        <a href="/"><h1 class="logo">ROSENTHAL FITNESS</h1></a>
        <a class="menu-btn" href="/">| | |</a>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./components/header.js